import { render, staticRenderFns } from "./ColumnController.vue?vue&type=template&id=8677d320&"
import script from "./ColumnController.vue?vue&type=script&lang=ts&"
export * from "./ColumnController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports